import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { initialState } from './state';
import { clearImpressionData, saveImpressionData, saveTrackingData } from './actions';

export default reducerWithInitialState(initialState)
    .case(saveTrackingData, (state, payload) => ({
        ...state,
        data: {
            ...payload,
            ...{ type: '' }, // TODO Take a closer look whats happening here
        },
    }))
    .case(saveImpressionData, (state, payload) => ({
        ...state,
        impression: [...state.impression, payload],
    }))
    .case(clearImpressionData, state => ({
        ...state,
        impression: initialState.impression,
    }));
